/* eslint-disable */
import axios from "@/axios";
import store from "@/store";

export function getMessages({ params, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.get("/messages", { headers, params, signal });
}

export function createMessage({ userId, params, payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  if (userId) {
    headers['x-operator-id'] = userId;
  }

  return axios.post("/messages", payload, { headers, params });
}

export function getMessage({ messageId, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.get(`/messages/${messageId}`, { headers, signal });
}

export function getMessagesForConversation({ conversationId, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.get(`/conversations/${conversationId}/messages`, { headers, signal });
}

export function createMessageReplyOnConversation({ conversationId, payload, params }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };
  return axios.put(`/conversations/${conversationId}/messages`, payload, { headers, params });
}

export function updateMessageStatus({ messageId, payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  return axios.put(`/messages/${messageId}/status`, payload, { headers });
}
